import React from "react";
import "./watchListTypeButtons.css";
// this component is specially for watch list multiple search!!!
const WatchListTypeButtons = ({ options, field, form: { setFieldValue } ,...props}) => {
  const valuesArr = getValue(options, field);

  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    if (option.value === "ALL") {
      return setFieldValue(field.name, ["ALL"]);
    }

    return setFieldValue(
      field.name,
      removeDuplicates([...field.value], newValue)
    );
  };
  const getClassName = (option) => {
    const base =
      "d-flex justify-content-around selectable-button-filters-file align-items-center ";
    if (!valuesArr.length) {
      return base;
    }

    if (valuesArr.includes(option.value)) {
      return base + "active-selectable-button";
    }
    return base;
  };

  return (
    <React.Fragment>
     
      <div className="button-select-filters-file-box">
      <p className="text-sm-center m-0 mt-3 mb-2" style={{fontSize:14}}>{props.label}</p>
        {options.map((option, i) => {
          return (
            <div
              key={`${i}-${option.value}`}
              className={getClassName(option)}
              color="primary"
              onClick={() => handleChange(option)}
            >
              {option.label}
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

function removeDuplicates(arr = [], value) {
  let temp = [...arr];
  if (!temp.includes(value)) {
    temp.push(value);
  } else {
    temp.splice(temp.indexOf(value), 1);
  }

  if (temp.includes("ALL") && value !== "ALL") {
    temp.splice(temp.indexOf("ALL"), 1);
    return temp;
  }

  return temp;
}

function getValue(options, field) {
  if (!options) {
    return [];
  }
  return field.value;
}

export default WatchListTypeButtons;



// WEBPACK FOOTER //
// ./src/components/formik/watchListType/WatchListTypeButtons.jsx